module.exports = __webpack_public_path__ + "static/media/destroyer_helmet.19bf4e4e.png";